import React from 'react';

class ManufacturersFacet extends React.Component {
    constructor(props) {
        super(props);
        this.facetRef = React.createRef();

        this.state = {
            desktopTogglerIsOpen: false,
        };
    }

    componentDidUpdate() {
        if (this.facetRef.current) {
            this.facetRef.current.scrollLeft = 0;
        }
    }

    render() {
        const { facets, onFacetChange, resourcedTexts } = this.props;
        const { desktopTogglerIsOpen } = this.state;

        const manufacturersFacet = facets.filter(
            ({ type, visible }) => type === 'manufacturers' && visible,
        )[0];

        if (!manufacturersFacet) return null;

        const manufacturersFacetItems = manufacturersFacet.items.filter((item) => item.visible);

        if (manufacturersFacetItems.length === 0) return null;

        manufacturersFacetItems.sort((a, b) => {
            if (a.value === true && b.value === false) {
                return -1;
            }
            if (a.value === false && b.value === true) {
                return 1;
            }
            return 0;
        });

        return (
            <div
                className={`sfr-manufacturers-facet ${
                    desktopTogglerIsOpen ? 'sfr-manufacturers-facet--show-all-on-desktop' : ''
                }`}
                ref={this.facetRef}
            >
                <ul>
                    {manufacturersFacetItems.map((item) => {
                        const { facetId, type } = manufacturersFacet;
                        const { itemId, name, value, imageUrl } = item;

                        return (
                            <li key={itemId}>
                                <input
                                    id={itemId}
                                    type="checkbox"
                                    name={facetId}
                                    checked={value}
                                    onChange={() => onFacetChange(facetId, type, item)}
                                />

                                <label className="sfr-manufacturers-facet__label" htmlFor={itemId}>
                                    {imageUrl ? <img src={imageUrl} alt={name} /> : name}
                                </label>
                            </li>
                        );
                    })}

                    {manufacturersFacetItems.length > 4 && (
                        <li className="sfr-manufacturers-facet__desktop-toggler">
                            <button
                                type="button"
                                onClick={() =>
                                    this.setState({ desktopTogglerIsOpen: !desktopTogglerIsOpen })
                                }
                            >
                                <span>
                                    {desktopTogglerIsOpen
                                        ? resourcedTexts.showLessManufacturers
                                        : resourcedTexts.showMoreManufacturers}
                                </span>
                            </button>
                        </li>
                    )}
                </ul>
            </div>
        );
    }
}

export { ManufacturersFacet };
